import { definePermisos } from '../utils'

export const RESOURCE_MANTENIMIENTO = 'Mantenimiento Maq PG'

export const permissionTree = definePermisos(RESOURCE_MANTENIMIENTO, 'manprog', {
    mantenimiento: {
        tiposMaquina: 'tipos-maquina',
        gestionEstrategia: 'gestion-estrategia',
        procesos: 'gestion-procesos',
        area: 'gestion-area',
        crearMaquinaria: 'crear-maquinaria',
        gestionTipoMaquina: 'gestion-maquinaria',
        gestionModelo: 'gestion-modelo',
        gestionPlanMantenimiento: 'gestion-plan-mantenimiento',
    },
    transacciones: {
        parametrizacionPlanesMantenimiento: 'parametrizacion-planes-mantenimiento',
        crearOrdenTrabajo: 'crear-ot',
        cerrarOrdenTrabajo: 'cerrar-ot',
        gestionOrdenTrabajo: 'gestion-ot',
    },
    informes: {
        listadoOrdenTrabajos: 'listado-orden-trabajo',
    },
    dashboard: {
        ordenesTrabajo: 'ordenes-trabajo',
        maquinas: 'maquinas',
        porMantenimiento: 'por-mantenimiento',
    },
})
